export default __webpack_public_path__ + "static/media/PierceWeakIcon.49b2ad57.png";